import { AxiosRequestConfig } from "axios";
import api from "../../../../lib/api";
import {
  ICustomerPricingPayload,
  ICustomerRateCreate,
  ICustomerRateListSearch,
  IEditCustomerRatePayload,
} from "../../../../types/master/customerRateInterface";

export const getCustomerPricingApi = async (customerId: number | string) => {
  return await api.get(`/customer-pricing/customer/${customerId}`);
};

export const updateCustomerPricingApi = async (payload: ICustomerPricingPayload) => {
  return await api.put("/customer-pricing/customer", payload);
};

export const createCustomerRateApi = async (data: ICustomerRateCreate) => {
  return await api.post("/customer-pricing/", data);
};

export const importCustomerRateByFileApi = async (formData: FormData, config?: AxiosRequestConfig) => {
  return await api.post("/customer-pricing/read-by-file", formData, config);
};

export const getCustomerRateDataByIdApi = async (id: number | string) => {
  return await api.get(`/customer-pricing/${id}`);
};

export const editCustomerRateDataByIdApi = async (payload: IEditCustomerRatePayload) => {
  return await api.put(`/customer-pricing/${payload.id}`, payload.data);
};

export const getCustomerRateListApi = async (data: ICustomerRateListSearch) => {
  return await api.get(`/customer-pricing/${data.page}/${data?.pageLimit ?? 10}`, {
    params: {
      customer_id: data.customer_id,
      search_key: data?.search_key ?? "",
      service_mode: data?.service_mode ?? "",
    },
  });
};

export const getCustomerRateZoneDropdownApi = async (data?: { page?: number; search?: string }) => {
  return await api.get(`/dropdowns/zone/${data?.page ?? 0}/25`, {
    params: { search: data?.search ?? "" },
  });
};
